import { render } from "./Score.vue?vue&type=template&id=23b63367&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"

import "./Score.vue?vue&type=style&index=0&id=23b63367&scoped=true&lang=css"

import exportComponent from "E:\\araya_2021\\tokuten\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b63367"]])

export default __exports__